import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import api from "../lib/api";

export default function ConventionLabel() {
  const { id } = useParams();
  const [o, setO] = useState(null);

  useEffect(() => {
    api.get(`/convention/orders/${id}`).then(({ data }) => setO(data)).catch(() => {});
  }, [id]);

  useEffect(() => {
    if (o) {
      const t = setTimeout(() => window.print(), 500);
      return () => clearTimeout(t);
    }
  }, [o]);

  if (!o) return null;
  const date = new Date(o.created_at).toLocaleString([], { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });

  return (
    <div className="label-root" data-testid="convention-label">
      <style>{`
        @page { size: 4in 6in; margin: 0; }
        @media print { html, body { margin: 0; } .no-print { display: none !important; } }
        .label-root { width: 4in; min-height: 6in; margin: 0 auto; padding: 0.22in; box-sizing: border-box; color: #0A0A0A; font-family: Arial, Helvetica, sans-serif; background: #fff; }
        .lbl-logo { height: 0.5in; display: block; margin: 0 auto 0.08in; }
        .lbl-title { text-align: center; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; color: #000; border-bottom: 2px solid #000; padding-bottom: 0.08in; }
        .lbl-order { display: flex; justify-content: space-between; align-items: baseline; margin-top: 0.12in; }
        .lbl-ono { font-size: 26px; font-weight: 900; }
        .lbl-date { font-size: 10px; color: #444; }
        .lbl-name { font-size: 20px; font-weight: 900; margin-top: 0.12in; }
        .lbl-contact { font-size: 13px; margin-top: 0.02in; }
        .lbl-h { font-size: 10px; letter-spacing: 1.5px; text-transform: uppercase; color: #555; margin-top: 0.16in; border-top: 1px dashed #bbb; padding-top: 0.08in; }
        .lbl-item { font-size: 14px; font-weight: 700; padding: 0.04in 0; border-bottom: 1px solid #eee; }
        .lbl-foot { position: relative; margin-top: 0.18in; border-top: 2px solid #000; padding-top: 0.08in; text-align: center; font-size: 10px; color: #333; }
        .lbl-web { font-size: 12px; font-weight: 900; color: #000; }
      `}</style>

      <button onClick={() => window.print()} className="no-print" style={{ position: "fixed", top: 12, right: 12, background: "#0A0A0A", color: "#fff", border: 0, borderRadius: 999, padding: "10px 18px", fontWeight: 800, display: "flex", gap: 8, alignItems: "center" }}>
        <Printer size={16} /> Print
      </button>

      <img className="lbl-logo" src="/mas-logo-black.png" alt="MAS Grading" />
      <div className="lbl-title">On-Site Grading Drop-Off</div>

      <div className="lbl-order">
        <div className="lbl-ono">{o.order_no}</div>
        <div className="lbl-date">{date}</div>
      </div>

      <div className="lbl-name">{o.customer_name}</div>
      <div className="lbl-contact">{o.phone}{o.email ? ` · ${o.email}` : ""}</div>

      <div className="lbl-h">Item(s) — {o.items.length}</div>
      {o.items.map((it, i) => (<div key={i} className="lbl-item">{i + 1}. {it}</div>))}

      <div className="lbl-foot">
        <div className="lbl-web">grading.mascertified.com</div>
        <div>MAS Certified, Inc. · PO Box 3153 · McAllen, TX 78502</div>
      </div>
    </div>
  );
}
